export const PVZ_PINCODE_ERROR = {
  attemptsExceeded:
    'Превышено количество попыток ввода. Получите новый ПИН-код от управляющего',
  rateLimit:
    'Превышен лимит запросов. Повторите попытку через 60 секунд.',
} as const;

export interface PvzPincodeErrorView {
  message: string;
  showHint: boolean;
}

export function classifyPvzPincodeError(
  message?: string,
  loginAttempts?: number | null,
): PvzPincodeErrorView | null {
  const text = (message ?? '').trim();
  const parsedAttempts = parseAttempts(loginAttempts);

  if (isRateLimitMessage(text)) {
    return {
      message: text || PVZ_PINCODE_ERROR.rateLimit,
      showHint: false,
    };
  }

  if (isAttemptsExceeded(text, parsedAttempts)) {
    return {
      message: text || PVZ_PINCODE_ERROR.attemptsExceeded,
      showHint: false,
    };
  }

  if (!text) {
    return null;
  }

  return {
    message: text,
    showHint: true,
  };
}

function parseAttempts(value?: number | null): number | null {
  if (value === null || value === undefined) {
    return null;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
}

function isRateLimitMessage(message: string): boolean {
  return /превышен лимит запросов/i.test(message);
}

function isAttemptsExceeded(
  message: string,
  loginAttempts: number | null,
): boolean {
  return (
    loginAttempts === 0 || /превышено количество попыток/i.test(message)
  );
}
